<!-- cards-list-grid w-100 mt-4 -->
<div class="d-flex flex-wrap">
  @for (science of sciences; track science) {
    <div class="card-container col-sm-6 col-lg-4 mt-md-3 mt-4">
      <app-apps-card
        [scienceIcon]="science.icon"
        [scienceTitle]="science.title"
        [scienceUrl]="science.url"
        [science]="science.app"
      ></app-apps-card>
    </div>
  }
</div>
